import React from 'react';

const Radio = ({ handleOnChange, selectedValue, name, id, value, label }) => {
  return (
    <div className="custom-radio">
      <input
        type="radio"
        name={name}
        id={id}
        className="custom-control-input"
        value={value}
        onChange={handleOnChange}
        checked={selectedValue === value}
      />
      <label className="custom-control-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default Radio;
